import { getCurrentLocale } from "../locale";

const FFB_LANDING_PRODUCTION = "https://flip.id/business";
const FFB_LANDING_PRODUCTION_EN = "https://flip.id/business/en";
const FFB_TNC_PRODUCTION = "https://flip.id/business/terms-and-conditions";
const FFB_TNC_PRODUCTION_EN = "https://flip.id/business/en/terms-and-conditions";

export function generateLandingPath() {
  const locale = getCurrentLocale();
  return locale === "en" ? FFB_LANDING_PRODUCTION_EN : FFB_LANDING_PRODUCTION;
}

export function generateTNCPath(hash = "") {
  const locale = getCurrentLocale();
  return (locale === "en" ? FFB_TNC_PRODUCTION_EN : FFB_TNC_PRODUCTION) + hash;
}
